import i18n from 'src/utils/translate';
import { connect } from 'react-redux';
import { unsetAlert } from './actions';
import { useAutoDismiss } from './hooks';
import { State, Props } from './types';

const Alert = (props : Props) => {
  const ref = useAutoDismiss<HTMLDivElement>(props);

  const { alert, unsetAlert } = props;
  if (!alert) return null;

  return (
    <div className={'alert site-alert alert-' + alert.type} ref={ref}>
      <div className="alert-container">
        {alert.message || i18n.t('There was a problem. Please refresh the page and try again.')}
        <button className="alert-close" type="button"
          onClick={unsetAlert}>&times;
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state: { alert: State }): Partial<Props> => {
  const { alert } = state.alert;
  return { alert };
};

export default connect(mapStateToProps, { unsetAlert })(Alert);
